import Vue from "vue";

[
  "Countdown",
  "Video",
  "Chat",
  "Avatar",
  "TimelineRotator",
  "AuthForm",
  "Alert",
  "AuthModal",
  "Spinner",
  "TilePreview",
  "ArticleSection",
  "SearchInput",
  "SearchInputMiddle",
  "Grid",
  "Uploader",
  "Recaptcha",
  "VimeoPlayer",
  "YoutubePlayer",
  "ZoomPlayer",
  "Tags",
  "Sidebar",
  "Banner",
  "SliderModal",
  "Schedule",
  "Sponsors",
  "EmailSubscribeModal",
  "InfoPopup",
  "ArticleSearchOnPage",
  "TerminusHeader",
  "TerminusSidebar",
  "ScheduleWrapper",
  "TerminusSectionHeader",
  "Partners",
  "Questions",
  "SearchOnPageInput",
  "RegistrationForm",
  "RegistrationFormHowToBuild",
  "RegistrationFormGS"
].forEach(e => {
  Vue.component(e, require(`./${e}.vue`).default);
});
